import React from 'react'
import { Checkbox, Form, Select } from 'antd'

export const SelectCommentsContainer = ({
    nameInput = [],
    isRequired = false,
    placeholder = "",
    disabled = false,
    options = [],
    checkedValue = false,
    onChangue = () => { }
}) => {

    return (
        <Form.Item
            name={nameInput}
            className="w-full mb-0"
            rules={[
                {
                    required: isRequired,
                    message: "Escoge uno por lo menos",
                },
            ]}
        >
            <Select
                disabled={disabled}
                mode="multiple"
                showSearch
                placeholder={placeholder}
                className="w-full text-[10px] md:text-[12px]"
                options={options}
                dropdownRender={(menu) => {
                    return (
                        <div className='p-4'>
                            <div className='mb-4 border-b-[0.5px] border-black pb-2 flex justify-between items-center'>
                                <span className='text-[10px] md:text-[12px]'>Todos</span>
                                <Checkbox checked={checkedValue} onChange={onChangue} />
                            </div>
                            <div className='flex flex-col '>
                                {menu}

                            </div>
                        </div>
                    )
                }}
            />
        </Form.Item>
    )
}
